import React, { useState, useEffect } from 'react';
import { DocumentsServices } from '../../services';
import { FileList } from '../../components';

function RelatoriosLegais() {
  const [legalReports, setLegalReports] = useState([]);
  useEffect(() => {
    async function fetchNews() {
      try {
        const response = await DocumentsServices.fetchDocuments('legalReports');
        setLegalReports(response.data);
      } catch (error) {
        console.log(error);
      }
    }

    fetchNews();
  }, []);
  return (
    <>
      <h1>Relatorios Legais</h1>
      <p>Esta página fornece acesso aos relatórios legais da <b>Cooperativa Cocrafi</b>.</p>
      <FileList  files={legalReports || []} />
    </>
  )
}

export default RelatoriosLegais;